import { ArquivarConsulta } from "./ArquivarConsulta";

export default ArquivarConsulta;